// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1JpNK","signatureButtonsRight":"ModalSign_signatureButtonsRight__e3Z8W"};